module.exports = __webpack_public_path__ + "img/yinzhou-edu-title.dc70a028.png";